import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		loader: false,
  		status: '',
  		token: localStorage.getItem('token') || '',
  		user : {
			correo: localStorage.getItem('correo'),
			nombre: localStorage.getItem('nombre'),
			apellido: localStorage.getItem('apellido'),  
			imagen: localStorage.getItem('imagen'),	  
			is_admin: localStorage.getItem('is_admin'),
			telefono: localStorage.getItem('telefono'),
			dia: localStorage.getItem('dia'),
			mes: localStorage.getItem('mes'),
			ano: localStorage.getItem('ano'),
			pais_idpais: localStorage.getItem('pais_idpais'),
			sexo: localStorage.getItem('sexo'),
			biografia: localStorage.getItem('biografia'),
			moneda: localStorage.getItem('moneda'),
			pref_moneda: localStorage.getItem('pref_moneda')	
		},
		alojamientos : {
			
		},
		accomodation: {
			tipo_moneda: localStorage.getItem('tipo_moneda')	
		},
		language: localStorage.getItem('language'),
		iso639_1: localStorage.getItem('iso639_1'),
		pais: localStorage.getItem('pais'),
		ciudad: localStorage.getItem('ciudad'),
		tipocambio: {}
	},
	mutations: {
		setLoading(state, payload){
		    state.loader = payload
	  	},	
		setUsuario(state, payload){
			state.user = payload
		},
		setAlojamientos(state, payload){
			state.alojamientos = payload
		},
		setAccomodation(state, payload){
			state.accomodation = payload
		},
		setLanguage(state, payload){
			state.language = payload
		},
		setIso639_1(state, payload){
			state.iso639_1 = payload
		},
		setPais(state, payload){
			state.pais = payload
		},
		setCiudad(state, payload){
			state.ciudad = payload
		},
		setMoneda(state, payload){
			state.user.moneda = payload
		},
		setTipoCambio(state, payload){
			state.tipocambio = payload
		},
		setMonedaCambio(state, payload){
			state.accomodation.tipo_moneda = payload
		},
		setSuccess(state, payload){
		    state.status = payload
		},
		setToken(state, payload){
		    state.token = payload
		  },		  	
	  	logout(state){
			state.status = '',
			state.token = '',
			state.user = '',
			state.alojamientos = '',
			state.accomodation = '',
			state.language = '',
			state.iso639_1 = '',
			state.pais = '',
			state.ciudad = '',	
			state.pref_moneda = '',
			state.moneda = ''	
	  	},
	},
	actions: {
	  	login({commit}, user){
				return new Promise(() => {
	            axios({url: process.env.VUE_APP_API_URL+'users/login', data: user, method: 'PUT' })
	            .then(resp => {
					let sex = ''
					if(resp.data.sexo == 'f'){
						sex = 'Femenino'
					}else{
						sex = 'Masculino'
					}

					let fecha = ''
					
					fecha = resp.data.fecha_nacimiento.split("-")
					
					localStorage.setItem('correo', resp.data.correo)
					localStorage.setItem('nombre', resp.data.nombre)
					localStorage.setItem('apellido', resp.data.apellido)
					localStorage.setItem('imagen', resp.data.imagen)
					localStorage.setItem('is_admin', resp.data.is_admin)
					localStorage.setItem('telefono', resp.data.telefono)
					localStorage.setItem('dia', fecha[2])
					localStorage.setItem('mes', fecha[1])
					localStorage.setItem('ano', fecha[0])
					localStorage.setItem('pais_idpais', resp.data.pais_idpais)
					localStorage.setItem('sexo', sex)
					localStorage.setItem('biografia', resp.data.biografia)	
					localStorage.setItem('token', resp.data.api_token)
					localStorage.setItem('pref_moneda', resp.data.pref_moneda)
					localStorage.setItem('moneda', '')
					localStorage.setItem('tipo_moneda', '')

					axios.defaults.headers.common['Authorization'] = resp.data.api_token				
					commit('setUsuario',{email:resp.data.correo, nombre:resp.data.nombre, apellido:resp.data.apellido, imagen:resp.data.imagen, is_admin:resp.data.is_admin, dia:fecha[2], mes:fecha[1], ano:fecha[0], pais_idpais: resp.data.pais_idpais, sexo: sex, biografia: resp.data.biografia, telefono: resp.data.telefono, pref_moneda: resp.data.pref_moneda, moneda: '', tipo_moneda: ''})
					commit('setToken', resp.data.api_token)
					commit('setSuccess','success')
					router.push({name: 'Dashboard'})
					
	            })
	        })
	    },
		register({commit}, user){
			let sex = ''
			
			if(user.sexo == 'Femenino'){
				sex = 'f'
			}else{
				sex = 'm'
			}

			let ano = user.fnacimiento.ano 
			let mes = user.fnacimiento.mes 
			let dia = user.fnacimiento.dia 

			let fnacimiento = ano +'-'+ mes +'-'+ dia

			let telefono = user.codigo_pais + user.telefono
			
			let userdata = new FormData()
			userdata.append('nombre', user.nombre)
			userdata.append('telefono', telefono)
			userdata.append('rut', user.rut)
			userdata.append('correo', user.email)            
			userdata.append('hash', user.contrasena)
			userdata.append('pais_idpais', user.nacionalidad)
			userdata.append('fecha_nacimiento', fnacimiento)
			userdata.append('sexo', sex)
			userdata.append('foto', user.foto)
			userdata.append('biografia', user.sobreti)

	        return new Promise(() => {
	            axios({url: process.env.VUE_APP_API_URL+'users/register', data: userdata, method: 'POST' })
	            .then(resp => {
					let sex = ''
					if(resp.data.user.sexo == 'f'){
						sex = 'Femenino'
					}else{
						sex = 'Masculino'
					}

					let fecha = ''
					
					fecha = resp.data.user.fecha_nacimiento.split("-")

					localStorage.setItem('correo', resp.data.user.correo)
					localStorage.setItem('nombre', resp.data.user.nombre)
					localStorage.setItem('apellido', resp.data.user.apellido)
					localStorage.setItem('telefono', resp.data.user.telefono)
					localStorage.setItem('imagen', resp.data.user.imagen)
					localStorage.setItem('is_admin', resp.data.user.is_admin)
					localStorage.setItem('telefono', resp.data.user.telefono)
					localStorage.setItem('dia', fecha[2])
					localStorage.setItem('mes', fecha[1])
					localStorage.setItem('ano', fecha[0])
					localStorage.setItem('pais_idpais', resp.data.user.pais_idpais)
					localStorage.setItem('sexo', sex)
					localStorage.setItem('biografia', resp.data.user.biografia)	
					localStorage.setItem('token', resp.data.user.api_token)
	                axios.defaults.headers.common['Authorization'] = resp.data.user.api_token
					commit('setUsuario',{email:resp.data.user.correo, nombre:resp.data.user.nombre, apellido:resp.data.user.apellido, imagen:resp.data.user.imagen, is_admin:resp.data.user.is_admin, dia:fecha[2], mes:fecha[1], ano:fecha[0], pais_idpais: resp.data.user.pais_idpais, sexo: sex, biografia: resp.data.user.biografia, telefono: resp.data.user.telefono})
					commit('setSuccess','success')
					commit('setToken', resp.data.user.api_token)
					router.push({name: 'Registro Alojamiento'})
	            })
			})
			
	    },
	  	logout({commit}){
		    return new Promise(() => {
				commit('logout')
				localStorage.removeItem('correo')
				localStorage.removeItem('nombre')
				localStorage.removeItem('apellido')
				localStorage.removeItem('imagen')
				localStorage.removeItem('is_admin')
				localStorage.removeItem('telefono')
				localStorage.removeItem('dia')
				localStorage.removeItem('mes')
				localStorage.removeItem('ano')
				localStorage.removeItem('fecha_nacimiento')
				localStorage.removeItem('sexo')
				localStorage.removeItem('pais_idpais')
				localStorage.removeItem('biografia')	
				localStorage.removeItem('token')
				localStorage.removeItem('language')	
				localStorage.removeItem('iso639_1')
				localStorage.removeItem('pais')
				localStorage.removeItem('ciudad')
				localStorage.removeItem('pref_moneda')
				localStorage.removeItem('moneda')
				localStorage.removeItem('tipo_moneda')
				
				

				delete axios.defaults.headers.common['Authorization']
				//router.push({name: 'login'})
				window.location.href = process.env.VUE_APP_SHARE_URL+'/auth/logout'
		    })
		  },
		  getAlojamientos({commit}){
			return new Promise(() => {
			axios({url: process.env.VUE_APP_API_URL+'accommodations/searchByUser', method: 'GET' })
			.then(resp => {
				commit('setAlojamientos',resp.data.accomodations)
				commit('setSuccess','success')
			})
			})
		},	
		registerAcommodation({commit}, accomodation){
			commit('setLoading', true)
				
			accomodation.gastoinmueble = accomodation.gastoinmueble == null ? 0 : accomodation.gastoinmueble;
			accomodation.serviciosb = accomodation.serviciosb == null ? 0 : accomodation.serviciosb;
			accomodation.gastos_comunes = accomodation.gastos_comunes == null ? 0 : accomodation.gastos_comunes;
			accomodation.limpieza = accomodation.limpieza == null ? 0 : accomodation.limpieza;
			accomodation.vdiario = accomodation.vdiario == null ? 0 : accomodation.vdiario;

			let accomodationdata = new FormData()
			accomodationdata.append('m2', accomodation.m2)
			accomodationdata.append('maximo_huespedes', accomodation.maximo_huespedes)            
			accomodationdata.append('direccion', accomodation.full_name)
			accomodationdata.append('latitud', accomodation.direccion.latitude)
			accomodationdata.append('longitud', accomodation.direccion.longitude)
			accomodationdata.append('tipo', accomodation.tipo)
			accomodationdata.append('arriendo', accomodation.arriendo)
			accomodationdata.append('gastos_comunes', accomodation.gastos_comunes)
			accomodationdata.append('reglas', accomodation.caracteristicas.rgenerales)
			accomodationdata.append('espacios_comunes', accomodation.caracteristicas.ecomunes)
			accomodationdata.append('uso_cocina', accomodation.caracteristicas.ucocina)
			accomodationdata.append('aseo_limpieza', accomodation.caracteristicas.alimpieza)
			accomodationdata.append('conserje', accomodation.caracteristicas.conserje)
			accomodationdata.append('timbre', accomodation.caracteristicas.timbre)
			accomodationdata.append('bodega', accomodation.caracteristicas.bodega)							
			accomodationdata.append('estacionamiento_privado', accomodation.caracteristicas.eprivado)
			accomodationdata.append('estacionamiento_visita', accomodation.caracteristicas.evisita)
			accomodationdata.append('estacionamiento_bicicleta', accomodation.caracteristicas.ebicicleta)
			accomodationdata.append('sala_estar', accomodation.caracteristicas.sestar)
			accomodationdata.append('sala_eventos', accomodation.caracteristicas.seventos)
			accomodationdata.append('jardines', accomodation.caracteristicas.jardines)
			accomodationdata.append('piscina', accomodation.caracteristicas.piscina)
			accomodationdata.append('gimnasio_interno', accomodation.caracteristicas.gimnasio)
			accomodationdata.append('desayuno', accomodation.caracteristicas.desayuno)
			accomodationdata.append('refrigerador', accomodation.caracteristicas.refrigerador)
			accomodationdata.append('cocina', accomodation.caracteristicas.cocina)
			accomodationdata.append('microondas', accomodation.caracteristicas.microondas)
			accomodationdata.append('parrilla', accomodation.caracteristicas.parrilla)
			accomodationdata.append('horno', accomodation.caracteristicas.horno)
			accomodationdata.append('lavadora', accomodation.caracteristicas.lavadora)
			accomodationdata.append('secadora', accomodation.caracteristicas.secadora)
			accomodationdata.append('plancha', accomodation.caracteristicas.plancha)
			accomodationdata.append('limpieza', accomodation.caracteristicas.limpieza)
			accomodationdata.append('mascotas', accomodation.caracteristicas.mascotas)
			accomodationdata.append('paradero_micro', accomodation.caracteristicas.paradero)
			accomodationdata.append('estacion_metro', accomodation.caracteristicas.metro)
			accomodationdata.append('hospital', accomodation.caracteristicas.csalud)
			accomodationdata.append('supermercado', accomodation.caracteristicas.supermercado)
			accomodationdata.append('banco', accomodation.caracteristicas.banco)
			accomodationdata.append('zona_nocturna', accomodation.caracteristicas.znocturna)
			accomodationdata.append('areas_verdes', accomodation.caracteristicas.averdes)
			accomodationdata.append('centro_comercial', accomodation.caracteristicas.comercial)
			accomodationdata.append('centro_civico', accomodation.caracteristicas.civico)
			accomodationdata.append('gimnasio_externo', accomodation.caracteristicas.gimnasioe)
			accomodationdata.append('hombres', accomodation.caracteristicas.hombres)
			accomodationdata.append('mujeres', accomodation.caracteristicas.mujeres)
			accomodationdata.append('ninos', accomodation.caracteristicas.ninos)
			accomodationdata.append('personal_servicio', accomodation.caracteristicas.pservicio)
			accomodationdata.append('tercera_edad', accomodation.caracteristicas.tedad)
			accomodationdata.append('perros', accomodation.caracteristicas.perros)
			accomodationdata.append('gatos', accomodation.caracteristicas.gatos)
			accomodationdata.append('otras_mascotas', accomodation.caracteristicas.omascotas)
			accomodationdata.append('sobre_nosotros', accomodation.caracteristicas.snosotros)
			accomodationdata.append('habitacion', accomodation.fotos.habitacion)
			accomodationdata.append('habitacion2', accomodation.fotos.habitacion2)
			accomodationdata.append('bano', accomodation.fotos.bano)
			accomodationdata.append('cocina1', accomodation.fotos.cocina1)
			accomodationdata.append('cocina2', accomodation.fotos.cocina2)
			accomodationdata.append('living', accomodation.fotos.living)
			accomodationdata.append('comedor', accomodation.fotos.comedor)
			accomodationdata.append('otro', accomodation.fotos.otro)
			accomodationdata.append('pieza', JSON.stringify(accomodation.pieza))
			accomodationdata.append('language', 'es')
			accomodationdata.append('tipo_moneda', accomodation.tipo_moneda)
			console.log("[ENVIADO]", accomodation);
	        return new Promise(() => {
	            axios({url: process.env.VUE_APP_API_URL+'accommodations/register', data: accomodationdata, method: 'POST' })
	            .then(resp => {	
					console.log("[RECEBIDO]", resp);	
					commit('setSuccess','success')	
					commit('setLoading', false)		
					router.push({name: 'Success'})					
	            })
			})
		},
		getPais({commit}){	
			 fetch('https://api.ipgeolocation.io/ipgeo?apiKey='+process.env.VUE_APP_GEOAPIKEY_URL)
            .then(function(response) {
                response.json().then(function(data) {
					let language = data.country_code2
					let pais = data.country_name
					let ciudad = data.country_capital
					localStorage.setItem('language', language)
					localStorage.setItem('pais', pais)
					localStorage.setItem('ciudad', ciudad)			
					commit('setLanguage', language)
					commit('setPais', pais)	
					commit('setCiudad', ciudad)	
					commit('setSuccess','success')

					fetch('https://restcountries.eu/rest/v2/alpha/'+language)
					.then(function(response) {
						response.json().then(function(data) {
						let iso639_1 = data.languages[0].iso639_1
						localStorage.setItem('iso639_1', iso639_1)	
						commit('setIso639_1', iso639_1)
						commit('setSuccess','success')
						});
					})					

                });
            })
		},
		cambioIdioma({commit}){
			if(this.state.iso639_1 === 'es'){
				commit('setIso639_1', 'en')
				localStorage.setItem('iso639_1', 'en')	
			}else{
				commit('setIso639_1', 'es')
				localStorage.setItem('iso639_1', 'es')	
			}
			commit('setSuccess','success')
		},		
		actualizarPerfil({commit}, user){
			
			let sex = ''
			
			if(user.sexo == 'Femenino'){
				sex = 'f'
			}else{
				sex = 'm'
			}

			let ano = user.fnacimiento.ano 
			let mes = user.fnacimiento.mes 
			let dia = user.fnacimiento.dia 

			let fnacimiento = ano +'-'+ mes +'-'+ dia

			let userdata = { 
			nombre: user.nombre, 
			apellido: user.apellido,
			telefono:  user.telefono,
			fecha_nacimiento: fnacimiento,
			pais_idpais: user.pais_idpais,
			sexo: sex,
			biografia: user.biografia
			}

	        return new Promise(() => {
				axios({url: process.env.VUE_APP_API_URL+'users/update', data: userdata, method: 'PUT' },
				{ headers: { "Content-Type": "application/x-www-form-urlencoded" }})
	            .then(resp => {

					let sex = ''
					if(resp.data.user.sexo == 'f'){
						sex = 'Femenino'
					}else{
						sex = 'Masculino'
					}

					let fecha = ''
					
					fecha = resp.data.user.fecha_nacimiento.split("-")
	
					localStorage.setItem('correo', resp.data.user.correo)
					localStorage.setItem('nombre', resp.data.user.nombre)
					localStorage.setItem('apellido', resp.data.user.apellido)
					localStorage.setItem('imagen', resp.data.user.imagen)
					localStorage.setItem('is_admin', resp.data.user.is_admin)
					localStorage.setItem('telefono', resp.data.user.telefono)
					localStorage.setItem('dia', fecha[2])
					localStorage.setItem('mes', fecha[1])
					localStorage.setItem('ano', fecha[0])
					localStorage.setItem('sexo', sex)
					localStorage.setItem('pais_idpais', resp.data.user.pais_idpais)
					localStorage.setItem('biografia', resp.data.user.biografia)
					
					commit('setUsuario',{
						correo:resp.data.user.correo, 
						nombre:resp.data.user.nombre, 
						apellido:resp.data.user.apellido, 
						imagen:resp.data.user.imagen, 
						is_admin:resp.data.user.is_admin,
						telefono: resp.data.user.telefono,
						dia:fecha[2], mes:fecha[1], ano:fecha[0],
						pais_idpais: resp.data.user.pais_idpais,
						sexo: sex,
						biografia: resp.data.user.biografia
					})

					alert('Perfil actualizado correctamente')
					commit('setSuccess','success')		

					
	            })
			})
			
		},
		actualizarPassword({commit}, user){
			
			let userdata = new FormData()
			userdata.append('contrasena', user.contrasena)
			userdata.append('contrasenan', user.contrasenan)
			userdata.append('contrasenar', user.contrasenar)    

			return new Promise(() => {
				axios({url: process.env.VUE_APP_API_URL+'users/changePassword', data: userdata, method: 'POST' })
				.then(resp => {
					commit('setSuccess','success')
					alert('Contraseña actualizada correctamente')
				})
			})					
		},
		eliminarAlojamiento({commit}, id){

			let mensaje = ''
			if(this.state.iso639_1 === 'es'){
				mensaje = 'Seguro que quieres eliminar tu alojamiento ' + id + '?'
		   }else{
			   mensaje = 'Surely you want to delete your accommodation ' + id + '?'
		   }
			if (confirm(mensaje)) {	
			commit('setLoading', true)	
			let alojamientodata = { 
				idalojamiento: id
				}

				return new Promise(() => {
					axios({url: process.env.VUE_APP_API_URL+'accommodations/deleteAccomodation', data: alojamientodata, method: 'DELETE' },
					{ headers: { "Content-Type": "application/x-www-form-urlencoded" }})
					.then(resp => {
						commit('setSuccess','success')
						return new Promise(() => {
							axios({url: process.env.VUE_APP_API_URL+'accommodations/searchByUser', method: 'GET' })
							.then(resp => {
								commit('setSuccess','success')
								commit('setLoading', false)	
								commit('setAlojamientos',resp.data.accomodations)
							})
						})
					})
				})	
			}			
		},
		wishList({commit}, id){
			let alojamientodata = { 
				alojamiento_idalojamiento: id
				}
				return new Promise(() => {
					axios({url: process.env.VUE_APP_API_URL+'wishList/change', data: alojamientodata, method: 'POST' },
					{ headers: { "Content-Type": "application/x-www-form-urlencoded" }})
					.then(resp => {
						return new Promise(() => {
							axios({url: process.env.VUE_APP_API_URL+'accommodations/searchByUser', method: 'GET' })
							.then(resp => {
								commit('setAlojamientos',resp.data.accomodations)
								commit('setSuccess','success')
							})
						})						
					})
				})				
		},
		clonar({commit}, id){
			
			let mensaje = ''
			if(this.state.iso639_1 === 'es'){
				 mensaje = 'Seguro que quieres clonar tu alojamiento ?'
			}else{
				mensaje = 'Are you sure you want to clone your accommodation?'
			}
			if (confirm(mensaje)) {
				commit('setLoading', true)	
				let alojamientodata = new FormData()
				alojamientodata.append('idalojamiento', id)    
	
				return new Promise(() => {
					axios({url: process.env.VUE_APP_API_URL+'accommodations/clone', data: alojamientodata, method: 'POST' })
					.then(resp => {
						commit('setSuccess','success')	
						
	
						return new Promise(() => {
							axios({url: process.env.VUE_APP_API_URL+'accommodations/searchByUser', method: 'GET' })
							.then(resp => {
								commit('setAlojamientos',resp.data.accomodations)
								commit('setSuccess','success')
								commit('setLoading', false)	
							})
						})
					})
				})
			} 							
		},
		  getAlojamiento({commit}, idalojamiento){
			commit('setLoading', true)	
			return new Promise(() => {
				axios({url: process.env.VUE_APP_API_URL+'accommodations/getAccomodation/'+idalojamiento, method: 'GET' })
				.then(resp => {
					commit('setAccomodation',{nombre:resp.data.accomodation.nombre, m2:resp.data.accomodation.m2, maximo_huespedes:resp.data.accomodation.maximo_huespedes, 
						direccion:resp.data.accomodation.direccion,  latitud:resp.data.accomodation.latitud,  longitud:resp.data.accomodation.longitud,
						tipo:resp.data.accomodation.tipo,  arriendo:resp.data.accomodation.arriendo,  gastos_comunes:resp.data.accomodation.gastos_comunes,
						reglas:resp.data.accomodation.reglas,  espacios_comunes:resp.data.accomodation.espacios_comunes,  uso_cocina:resp.data.accomodation.uso_cocina,
						aseo_limpieza:resp.data.accomodation.aseo_limpieza,  conserje:resp.data.accomodation.conserje,  timbre:resp.data.accomodation.timbre,
						bodega:resp.data.accomodation.bodega,  estacionamiento_privado:resp.data.accomodation.estacionamiento_privado,  estacionamiento_visita:resp.data.accomodation.estacionamiento_visita,
						estacionamiento_bicicleta:resp.data.accomodation.estacionamiento_bicicleta, sala_estar:resp.data.accomodation.sala_estar, sala_eventos:resp.data.accomodation.sala_eventos,
						jardines:resp.data.accomodation.jardines, piscina:resp.data.accomodation.piscina, gimnasio_interno:resp.data.accomodation.gimnasio_interno,
						desayuno:resp.data.accomodation.desayuno, refrigerador:resp.data.accomodation.refrigerador, cocina:resp.data.accomodation.cocina,
						horno:resp.data.accomodation.horno, microondas:resp.data.accomodation.microondas, parrilla:resp.data.accomodation.parrilla,
						lavadora:resp.data.accomodation.lavadora, secadora:resp.data.accomodation.secadora, plancha:resp.data.accomodation.plancha,
						limpieza:resp.data.accomodation.limpieza, mascotas:resp.data.accomodation.mascotas, paradero_micro:resp.data.accomodation.paradero_micro,
						estacion_metro:resp.data.accomodation.estacion_metro, hospital:resp.data.accomodation.hospital, supermercado:resp.data.accomodation.supermercado,
						banco:resp.data.accomodation.banco, zona_nocturna:resp.data.accomodation.zona_nocturna, areas_verdes:resp.data.accomodation.areas_verdes,
						centro_comercial:resp.data.accomodation.centro_comercial, centro_civico:resp.data.accomodation.centro_civico, gimnasio_externo:resp.data.accomodation.gimnasio_externo,
						hombres:resp.data.accomodation.hombres, mujeres:resp.data.accomodation.mujeres, ninos:resp.data.accomodation.ninos,
						personal_servicio:resp.data.accomodation.personal_servicio, tercera_edad:resp.data.accomodation.tercera_edad, perros:resp.data.accomodation.perros,
						gatos:resp.data.accomodation.gatos, otras_mascotas:resp.data.accomodation.otras_mascotas,
						sobre_nosotros:resp.data.accomodation.sobre_nosotros, piezas:resp.data.accomodation.piezas, idalojamiento:resp.data.accomodation.idalojamiento
					})	
					commit('setSuccess','success')
					commit('setLoading', false)	
				})
			})		
		},	
		updateAcommodation({commit}, accomodation){
			commit('setLoading', true)
			let accomodationdata = new FormData()
			accomodationdata.append('idalojamiento', accomodation.idalojamiento)
			accomodationdata.append('m2', accomodation.m2)
			accomodationdata.append('maximo_huespedes', accomodation.maximo_huespedes)            
			accomodationdata.append('direccion', accomodation.full_name)
			accomodationdata.append('latitud', accomodation.direccion.latitude)
			accomodationdata.append('longitud', accomodation.direccion.longitude)
			accomodationdata.append('tipo', accomodation.tipo)
			accomodationdata.append('arriendo', accomodation.arriendo)
			accomodationdata.append('gastos_comunes', accomodation.gastos_comunes)
			accomodationdata.append('reglas', accomodation.caracteristicas.rgenerales)
			accomodationdata.append('espacios_comunes', accomodation.caracteristicas.ecomunes)
			accomodationdata.append('uso_cocina', accomodation.caracteristicas.ucocina)
			accomodationdata.append('aseo_limpieza', accomodation.caracteristicas.alimpieza)
			accomodationdata.append('conserje', accomodation.caracteristicas.conserje)
			accomodationdata.append('timbre', accomodation.caracteristicas.timbre)
			accomodationdata.append('bodega', accomodation.caracteristicas.bodega)							
			accomodationdata.append('estacionamiento_privado', accomodation.caracteristicas.eprivado)
			accomodationdata.append('estacionamiento_visita', accomodation.caracteristicas.evisita)
			accomodationdata.append('estacionamiento_bicicleta', accomodation.caracteristicas.ebicicleta)
			accomodationdata.append('sala_estar', accomodation.caracteristicas.sestar)
			accomodationdata.append('sala_eventos', accomodation.caracteristicas.seventos)
			accomodationdata.append('jardines', accomodation.caracteristicas.jardines)
			accomodationdata.append('piscina', accomodation.caracteristicas.piscina)
			accomodationdata.append('gimnasio_interno', accomodation.caracteristicas.gimnasio)
			accomodationdata.append('desayuno', accomodation.caracteristicas.desayuno)
			accomodationdata.append('refrigerador', accomodation.caracteristicas.refrigerador)
			accomodationdata.append('cocina', accomodation.caracteristicas.cocina)
			accomodationdata.append('microondas', accomodation.caracteristicas.microondas)
			accomodationdata.append('parrilla', accomodation.caracteristicas.parrilla)
			accomodationdata.append('horno', accomodation.caracteristicas.horno)
			accomodationdata.append('lavadora', accomodation.caracteristicas.lavadora)
			accomodationdata.append('secadora', accomodation.caracteristicas.secadora)
			accomodationdata.append('plancha', accomodation.caracteristicas.plancha)
			accomodationdata.append('limpieza', accomodation.caracteristicas.limpieza)
			accomodationdata.append('mascotas', accomodation.caracteristicas.mascotas)
			accomodationdata.append('paradero_micro', accomodation.caracteristicas.paradero)
			accomodationdata.append('estacion_metro', accomodation.caracteristicas.metro)
			accomodationdata.append('hospital', accomodation.caracteristicas.csalud)
			accomodationdata.append('supermercado', accomodation.caracteristicas.supermercado)
			accomodationdata.append('banco', accomodation.caracteristicas.banco)
			accomodationdata.append('zona_nocturna', accomodation.caracteristicas.znocturna)
			accomodationdata.append('areas_verdes', accomodation.caracteristicas.averdes)
			accomodationdata.append('centro_comercial', accomodation.caracteristicas.comercial)
			accomodationdata.append('centro_civico', accomodation.caracteristicas.civico)
			accomodationdata.append('gimnasio_externo', accomodation.caracteristicas.gimnasioe)
			accomodationdata.append('hombres', accomodation.caracteristicas.hombres)
			accomodationdata.append('mujeres', accomodation.caracteristicas.mujeres)
			accomodationdata.append('ninos', accomodation.caracteristicas.ninos)
			accomodationdata.append('personal_servicio', accomodation.caracteristicas.pservicio)
			accomodationdata.append('tercera_edad', accomodation.caracteristicas.tedad)
			accomodationdata.append('perros', accomodation.caracteristicas.perros)
			accomodationdata.append('gatos', accomodation.caracteristicas.gatos)
			accomodationdata.append('otras_mascotas', accomodation.caracteristicas.omascotas)
			accomodationdata.append('sobre_nosotros', accomodation.caracteristicas.snosotros)
			accomodationdata.append('idhabitacion', accomodation.fotos.idhabitacion)
			accomodationdata.append('habitacion', accomodation.fotos.habitacion)
			accomodationdata.append('idhabitacion2', accomodation.fotos.idhabitacion2)
			accomodationdata.append('habitacion2', accomodation.fotos.habitacion2)
			accomodationdata.append('idbano', accomodation.fotos.idbano)
			accomodationdata.append('bano', accomodation.fotos.bano)
			accomodationdata.append('idcocina1', accomodation.fotos.idcocina1)
			accomodationdata.append('cocina1', accomodation.fotos.cocina1)
			accomodationdata.append('idcocina2', accomodation.fotos.idcocina2)
			accomodationdata.append('cocina2', accomodation.fotos.cocina2)
			accomodationdata.append('idliving', accomodation.fotos.idliving)
			accomodationdata.append('living', accomodation.fotos.living)
			accomodationdata.append('idcomedor', accomodation.fotos.idcomedor)
			accomodationdata.append('comedor', accomodation.fotos.comedor)
			accomodationdata.append('idotro', accomodation.fotos.idotro)
			accomodationdata.append('otro', accomodation.fotos.otro)
			accomodationdata.append('pieza', JSON.stringify(accomodation.pieza))
			accomodationdata.append('language', 'es')
			accomodationdata.append('tipo_moneda', accomodation.tipo_moneda)
			
	        return new Promise((resolve) => {
	            axios({url: process.env.VUE_APP_API_URL+'accommodations/update', data: accomodationdata, method: 'POST' })
	            .then(resp => {		
					commit('setSuccess','success')	
					commit('setLoading', false)		
					router.push({name: 'Update'})	
									
	            })
			})
		},
		getTipoCambio({commit}){
			return new Promise(() => {
			axios({url: process.env.VUE_APP_API_URL+'exchange', method: 'GET' })
			.then(resp => {
				commit('setTipoCambio', resp.data)
			})
			})
		},
		setMoneda({commit}, moneda){
			localStorage.setItem('moneda', moneda)
			commit('setMoneda', moneda)
		},
		setMonedaCambio({commit}, tipo_moneda){
			localStorage.setItem('tipo_moneda', tipo_moneda)
			commit('setMonedaCambio', tipo_moneda)
		},																																  
	},
	getters : {
	  isLoggedIn: state => !!state.token,
	  authStatus: state => state.status,
	}
})
